import React from "react";
import Dialog from "components/odl-v2/Dialog/Dialog";
import { Typography } from "@mui/material";
import DialogActions from "components/odl-v2/Dialog/DialogActions";
import { styled } from "@mui/material/styles";
import { css } from "@emotion/react";
import DialogContent from "components/odl-v2/Dialog/DialogContent";
import { useTranslation } from "react-i18next";
import DialogActionPrimary from "components/odl-v2/Dialog/DialogActionPrimary";
import DialogActionGroup from "components/odl-v2/Dialog/DialogActionGroup";
import FlexBox from "components/FlexBox/FlexBox";
import Spacer from "components/Spacer/Spacer";
import { ReactComponent as SystemGroupAccessIcon } from "assets/images/system-group-access.svg";

type Props = {
  onClose: () => void;
};

const AccessRequestConfirmationDialog: React.FC<Props> = ({ onClose }) => {
  const { t } = useTranslation();

  const DialogTitle = (
    <FlexBox alignItems={"center"}>
      <SystemGroupAccessIcon width={20} height={20} />
      <Spacer x={4} />
      {t(`Access request submitted`)}
    </FlexBox>
  );

  return (
    <Dialog
      open={true}
      data-testid={"AccessRequestConfirmationDialog"}
      title={DialogTitle}
      onClose={onClose}
      scroll="body"
    >
      <StyledDialogContent>
        <StyledTypography variant={"h3"}>What happens next</StyledTypography>
        <StyledTypography variant="body1">
          The system notifies the manager of the project. Your profile information is included in the notification.
        </StyledTypography>
        <StyledTypography variant="body1">
          <ul>
            <li>{t(`They may accept or decline your request`)}</li>
            <li>
              {t(`If a manager does not respond, your request expires automatically in seven (7) calendar days.`)}
            </li>
          </ul>
        </StyledTypography>
        <StyledTypography variant="body1">{t(`The system notifies you of the outcome.`)}</StyledTypography>
      </StyledDialogContent>

      <DialogActions>
        <DialogActionGroup></DialogActionGroup>
        <DialogActionGroup>
          <DialogActionPrimary data-testid="CloseButton" onClick={onClose}>
            {t(`Close`)}
          </DialogActionPrimary>
        </DialogActionGroup>
      </DialogActions>
    </Dialog>
  );
};

const StyledTypography = styled(Typography)(
  ({ theme }) => css`
    line-height: 1.5rem;
    margin-top: 0;
    margin-bottom: 1rem;
  `
);

const StyledDialogContent = styled(DialogContent)(
  ({ theme }) => css`
    max-width: 500px;
  `
);

export default AccessRequestConfirmationDialog;
